import React from 'react';

type Ton = 'gruen' | 'grau' | 'rot';

interface StatusAmpelProps {
  status: string;
  laeuft: boolean;
}

/** Statuspunkt + Text. Der Live-Zustand (laeuft) entscheidet die Farbe,
 *  nicht der zuletzt in der Registry gespeicherte Status. */
const StatusAmpel: React.FC<StatusAmpelProps> = ({ status, laeuft }) => {
  let ton: Ton = 'grau';
  if (status === 'FEHLER') ton = 'rot';
  else if (laeuft) ton = 'gruen';

  const beschriftung = laeuft ? 'Läuft' : status === 'FEHLER' ? 'Fehler' : 'Gestoppt';

  return (
    <span className={`k-ampel k-ampel--${ton}`}>
      <span className="k-ampel__dot" />
      {beschriftung}
    </span>
  );
};

export default StatusAmpel;
